import type { FoodOutDetailsListModel, KitchenScheduleSettingsModel } from '@/model/kitchen';

export const isValidKitchenAdvanceMinutes = (value: unknown): value is number =>
  typeof value === 'number' &&
  Number.isSafeInteger(value) &&
  value >= 0 &&
  value * 60000 <= 8640000000000000;

export const defaultKitchenScheduleSettings = (): KitchenScheduleSettingsModel => ({
  advanceMinutes: 30,
});

// 预约日期和时段均按北京时间处理，避免设备时区影响制作安排。
export const kitchenAppointmentTime = (task: FoodOutDetailsListModel): number | null => {
  if (![2, 3].includes(task.dineType || 0)) return null;
  const date = task.selfPickDate?.trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/);
  const time = task.selfPickTime
    ?.trim()
    .match(/^(\d{1,2}):(\d{2})(?:\s*[-–—]\s*(\d{1,2}):(\d{2}))?$/);
  if (!date || !time) return null;
  const [, year, month, day] = date;
  const hour = Number(time[1]);
  const minute = Number(time[2]);
  if (hour > 23 || minute > 59) return null;
  if (time[3] !== undefined && (Number(time[3]) > 23 || Number(time[4]) > 59)) return null;
  const timestamp = Date.parse(
    `${year}-${month}-${day}T${String(hour).padStart(2, '0')}:${time[2]}:00+08:00`,
  );
  if (!Number.isFinite(timestamp)) return null;
  const normalized = new Date(timestamp + 8 * 60 * 60 * 1000);
  if (
    normalized.getUTCFullYear() !== Number(year) ||
    normalized.getUTCMonth() + 1 !== Number(month) ||
    normalized.getUTCDate() !== Number(day)
  )
    return null;
  return timestamp;
};

export const kitchenReleaseTime = (
  task: FoodOutDetailsListModel,
  settings: KitchenScheduleSettingsModel,
): number | null => {
  const appointment = kitchenAppointmentTime(task);
  return appointment === null ? null : appointment - settings.advanceMinutes * 60000;
};

export const isKitchenTaskScheduled = (
  task: FoodOutDetailsListModel,
  settings: KitchenScheduleSettingsModel,
  now = Date.now(),
): boolean => {
  if (task.kitchenStatus !== 0 || task.operateStatus === 1 || [8, 9, 999].includes(task.status))
    return false;
  // 已手动开始的任务即使被暂停/退回，也继续走原制作流程。
  if (task.startTime?.trim() && Number.isFinite(Date.parse(task.startTime.replace(' ', 'T'))))
    return false;
  const release = kitchenReleaseTime(task, settings);
  return release !== null && now < release;
};
